import type { Article, ArticleAsset } from '@/types/';

export const useArticleStore = defineStore('articleStore', () => {
  const articles = ref<Article[]>([]);
  const allArticles = ref<ArticleAsset[]>([]);
  const featuredArticles = ref<ArticleAsset[]>([]);

  async function getArticles() {
    const resp = await $fetch('/api/articles');
    return (articles.value = resp ?? []);
  }

  async function getAllArticles() {
    const resp = await $fetch('/api/assets-by-type');
    return (allArticles.value = resp ?? []);
  }

  async function getFeaturedArticles() {
    if (!allArticles.value || !allArticles.value.length) {
      await getAllArticles();
      featuredArticles.value = sortFeaturedArticles.value;
    }

    return featuredArticles.value;
  }

  const sortFeaturedArticles = computed(() => {
    if (!allArticles.value || !allArticles.value.length) return [];
    const featured = allArticles.value.filter((article) => {
      return article.publishingStatus === 'Published' && article.fields.is_featured;
    });
    return featured.sort((a, b) => a.fields.order.value - b.fields.order.value);
  });

  const articlesByYear = computed(() => {
    const articlesByYear: { year: string; articles: Article[] }[] = [];
    articles.value.forEach((article) => {
      const year = new Date(article.date).getFullYear().toString();
      if (articlesByYear.find((item) => item.year === year)) {
        articlesByYear.find((item) => item.year === year)!.articles.push(article);
      } else {
        articlesByYear.push({
          year,
          articles: [article],
        });
      }
    });

    return articlesByYear.sort((a, b) => parseInt(b.year) - parseInt(a.year));
  });

  return {
    articles,
    getArticles,
    getFeaturedArticles,
    featuredArticles,
    articlesByYear,
  };
});
